import { Button, Form, Select, notification } from 'antd';
import { Option } from 'antd/lib/mentions';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import {
  AssetManagerType,
  PackType,
} from '../../../../redux/userStore/reducer';
import { ORANGE } from '../../../../shared/colors';
import {
  addAbonnement,
  getAssetManagers,
  listAbonnement,
} from '../../../dashboard/network';

export const AbonnementForm = ({
  setShowDrawer,
  settheasset,
  pack,
  getNewAsset,
}: {
  setShowDrawer: (b: boolean) => void;
  settheasset: AssetManagerType;
  pack: PackType[];
  getNewAsset: (part: AssetManagerType[]) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );

  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.manager = settheasset.id;
          await addAbonnement(connectedUser.id, data).then(
            ({ statusCode, data }) => {
              if (statusCode.toString()[0] === '2') {
                notification.success({
                  message: 'Abonnement souscrit',
                  description: "L'abonnement a été souscrit avec succès",
                });
                getAssetManagers().then(({ data: filterClient }) => {
                  filterClient.map((item: AssetManagerType) => {
                    item.abonnement = [];
                    listAbonnement(connectedUser.id, item.id).then(
                      ({ data }) => {
                        item.abonnement = data;
                      },
                    );
                    return item;
                  });
                  getNewAsset(filterClient);
                });
                setShowDrawer(false);
              } else {
                notification.error({
                  message: 'Erreur',
                  description: data.message,
                });
              }
              setIsLoading(false);
            },
          );
        }}
      >
        <Form.Item
          label='Pack sélectionné'
          name='pack'
          hasFeedback
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <Select placeholder='Selectionnez un pack'>
            {pack.map((pac) => (
              <Option key={pac.id} value={pac.id}>
                {pac.nom}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
